'use strict';

module.exports = function (x) {
	if (!x) return false;
	if (typeof x === 'symbol') return true;
	if (!x.constructor) return false;
	if (x.constructor.name !== 'Symbol') return false;
	return (x[x.constructor.toStringTag] === 'Symbol');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es6-symbol/is-symbol.js
 ** module id = 739
 ** module chunks = 0
 **/